jQuery(document).ready(function($){

    /** ========== Function to move the product count in Collection Listing Page ========== **/
  const moveCollectionCounts = () => {
    const collectionContainers = document.querySelectorAll('.template--list-collections .featured-grid--item--container');
    collectionContainers.forEach(container => {
      const count = container.querySelector('.collection-product-count');
      const title = container.querySelector('.stacked-text--title');
      if (count && title) { title.insertAdjacentElement('afterend', count); }
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveCollectionCounts);
  }
   else { 
    moveCollectionCounts();
}
  document.addEventListener('shopify:section:load', moveCollectionCounts);

const btn = document.getElementById("btn-text");
const content = document.getElementById("show-more");

if (btn && content) {
  btn.removeAttribute("onclick"); // Clean old handler
  btn.onclick = (e) => {
    e.preventDefault();
    const isHidden = content.style.display === "none" || content.style.display === "";
    content.style.display = isHidden ? "block" : "none";
    btn.innerText = isHidden ? "Read Less" : "Read More";
  };
}

/* footer link change*/
$('footer .footer--wrapper .footer--block:nth-child(2) ul li:last-child()').html('<p>In association with Angel Bins&nbsp;<a href="https://thefundraisingcompany.com/" title="https://thefundraisingcompany.com/" target="_blank">Fundraising</a>,&nbsp;<a href="https://www.samiyatex.com/" title="https://www.samiyatex.com/" target="_blank">Samiyatex</a></p>')
/* wrap footer logo in a tag */
$('.footer-logo-wrapper img').wrap('<a href="https://lavintage.com"></a>');
/* footer bar text*/
$('.footer-bar--text').html('Copyright © 2026 <a href="/" title="">LA Vintage Wholesale </a>. All Rights Reserved. Privacy Policy | <a href="https://lavintage.com/pages/terms-conditions">Terms &amp; Conditions</a> |<a href="/sitemap.xml"> Site Map</a>')
  /* main function ends here*/
});




